import React, { useEffect, useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import { Link, useNavigate } from "react-router-dom";
import "./addTeamMember.css";
import AddImage from "../../Global Functions/addImage";
import { addTeamMember } from "../../Redux/Actions/teamMembersAction";
import { useDispatch, useSelector } from "react-redux";
import {
  viewCityListPagination,
  viewCountryListPagination,
  viewStateListPagination,
} from "../../Redux/Actions/settingsActions";
import toast from "react-hot-toast";
import { getEnums } from "../../Redux/Actions/enumsActions";
import { ToFirstCapital } from "../../Utils/helpers";

const AddTeamMember = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { enumsData } = useSelector((state) => state.enumsData);
  const { countryList } = useSelector((state) => state.country);
  const { states } = useSelector((state) => state.states);
  const { cities } = useSelector((state) => state.city);

  const [confirmPass, setConfirmPass] = useState("");
  const [reAccount, setReAccount] = useState("");
  const [accMatch, setAccMatch] = useState(true);
  const [previewImage, setPreviewImage] = useState(null);
  const [activeSection, setActiveSection] = useState(0);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});

  const sections = ["Personal Info", "Work Details", "Security", "Address", "Documents", "Bank Details"];

  const todayStr = new Date().toISOString().split("T")[0];

  const [memberData, setMemberData] = useState({
    profile_image: "",
    name: "",
    email: "",
    country_code: "",
    contact_number: "",
    role: "",
    timezone: "",
    pwd: "",
    lat: "12",
    lng: "12",
    gender: "",
    age: "",
    dob: "",
    city: "",
    state: "",
    country: "",
    joining_date: "",
    qualifications: [{ degree: "" }],
    experience: "",
    address: "",
    branch_address: "",
    department: "",
    zip_code: "",
    designation: "",
    document_list: [{ name: "", url: "" }],
    bank_details: [{ acc_num: "", ifsc: "", acc_holder_name: "" }],
  });

  const [stateData, setStateData] = useState({ country: "" });
  const [cityData, setCityData] = useState({ state: "", country: "" });

  const deptArray = ["payments", "business"];

  useEffect(() => { dispatch(getEnums()); }, [dispatch]);
  useEffect(() => { dispatch(viewCountryListPagination()); }, [dispatch]);
  useEffect(() => {
    if (stateData.country !== "") dispatch(viewStateListPagination(stateData));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateData.country]);
  useEffect(() => {
    if (cityData.state !== "") dispatch(viewCityListPagination(cityData));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cityData.state]);

  const clearError = (field) => {
    setFieldErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const handleImageChange = async (event) => {
    const uploadedImage = event.target.files[0];
    if (!uploadedImage) return;
    try {
      const imageUrl = await AddImage(uploadedImage);
      setMemberData((prev) => ({ ...prev, profile_image: imageUrl }));
      setPreviewImage(URL.createObjectURL(uploadedImage));
    } catch (error) {
      console.log("Error uploading image:", error.message);
    }
  };

  // Tracks selected display names separately so dropdowns show correct selected value
  const [selectedCountryName, setSelectedCountryName] = useState("");
  const [selectedStateName, setSelectedStateName] = useState("");
  const [selectedCityName, setSelectedCityName] = useState("");

  const handleAddChange = (event) => {
    const { name, value } = event.target;
    clearError(name);

    if (name === "country") {
      const selectedCountry = countryList?.data?.find((c) => c.country_name === value);
      const countryId = selectedCountry?._id || "";
      setSelectedCountryName(value);
      setSelectedStateName("");
      setSelectedCityName("");
      setMemberData((prev) => ({ ...prev, country: countryId, state: "", city: "" }));
      setStateData({ country: countryId });
      setCityData({ state: "", country: countryId });
      return;
    }

    if (name === "state") {
      const selectedState = states?.data?.find((s) => s.state_name === value);
      const stateId = selectedState?._id || "";
      setSelectedStateName(value);
      setSelectedCityName("");
      setMemberData((prev) => ({ ...prev, state: stateId, city: "" }));
      setCityData((prev) => ({ ...prev, state: stateId }));
      return;
    }

    if (name === "city") {
      const selectedCity = cities?.data?.find((c) => c.city_name === value);
      const cityId = selectedCity?._id || "";
      setSelectedCityName(value);
      setMemberData((prev) => ({ ...prev, city: cityId }));
      return;
    }

    setMemberData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = async (event, index) => {
    try {
      const uploadedImage = event.target.files[0];
      if (!uploadedImage) return;
      const imageUrl = await AddImage(uploadedImage);
      if (!imageUrl) return;
      setMemberData((prev) => {
        const updatedDocuments = [...prev.document_list];
        if (!updatedDocuments[index]) updatedDocuments[index] = { name: "", url: "" };
        updatedDocuments[index].url = imageUrl;
        return { ...prev, document_list: updatedDocuments };
      });
      clearError("doc_url");
    } catch (error) {
      console.error("Error uploading file:", error.message);
    }
  };

  const handleNameChange = (event) => {
    const newName = event.target.value;
    clearError("doc_name");
    setMemberData((prev) => {
      const updatedDocumentList = prev.document_list ? [...prev.document_list] : [];
      if (updatedDocumentList.length === 0) {
        updatedDocumentList.push({ name: newName, url: "" });
      } else {
        updatedDocumentList[0] = { ...updatedDocumentList[0], name: newName };
      }
      return { ...prev, document_list: updatedDocumentList };
    });
  };

  const handleCheckPass = () => {
    if (confirmPass && memberData.pwd !== confirmPass) {
      toast.error("Passwords do not match");
      setFieldErrors((prev) => ({ ...prev, confirmPass: "Passwords do not match" }));
    } else {
      setFieldErrors((prev) => ({ ...prev, confirmPass: "" }));
    }
  };

  const handleCheckAcc = () => {
    if (reAccount && memberData?.bank_details?.[0]?.acc_num !== reAccount) {
      setAccMatch(false);
      toast.error("Account Numbers Don't Match");
    } else if (reAccount && memberData?.bank_details?.[0]?.acc_num === reAccount) {
      setAccMatch(true);
    }
  };

  const handleBankDetails = (event) => {
    const { name, value } = event.target;
    setMemberData((prev) => ({
      ...prev,
      bank_details: [{ ...prev.bank_details[0], [name]: value }],
    }));
  };

  // ── Section-level validation ──────────────────────────────────────────────
  const validateSection = (sectionIndex) => {
    const errors = {};

    if (sectionIndex === 0) {
      if (!memberData.name.trim()) errors.name = "Full name is required";
      if (!memberData.email.trim() || !memberData.email.includes("@"))
        errors.email = "Valid email address is required";
      if (!memberData.country_code) errors.country_code = "Country code is required";
      if (!memberData.contact_number.trim())
        errors.contact_number = "Phone number is required";
      if (!memberData.gender) errors.gender = "Gender is required";
      if (!memberData.dob) {
        errors.dob = "Date of birth is required";
      } else if (new Date(memberData.dob) > new Date()) {
        errors.dob = "Date of birth cannot be in the future";
      }
      if (!memberData.age || Number(memberData.age) < 0)
        errors.age = "Valid age is required";
    }

    if (sectionIndex === 1) {
      if (!memberData.role) errors.role = "Role is required";
      if (!memberData.designation.trim()) errors.designation = "Designation is required";
      if (!memberData.department) errors.department = "Department is required";
      if (!memberData.timezone) errors.timezone = "Time zone is required";
      if (!memberData.joining_date) {
        errors.joining_date = "Joining date is required";
      } else if (new Date(memberData.joining_date) > new Date()) {
        errors.joining_date = "Joining date cannot be in the future";
      }
      if (!memberData.experience || Number(memberData.experience) < 0)
        errors.experience = "Valid experience is required";
      if (!memberData.qualifications?.[0]?.degree)
        errors.qualifications = "Qualification is required";
      if (!memberData.branch_address?.trim())
        errors.branch_address = "Branch address is required";
    }

    if (sectionIndex === 2) {
      if (!memberData.pwd) errors.pwd = "Password is required";
      if (!confirmPass) errors.confirmPass = "Please confirm your password";
      if (memberData.pwd && confirmPass && memberData.pwd !== confirmPass)
        errors.confirmPass = "Passwords do not match";
    }

    if (sectionIndex === 3) {
      if (!memberData.address.trim()) errors.address = "Street address is required";
      if (!memberData.country) errors.country = "Country is required";
      if (!memberData.state) errors.state = "State is required";
      if (!memberData.city) errors.city = "City is required";
      if (!memberData.zip_code) errors.zip_code = "Zip / postal code is required";
    }

    if (sectionIndex === 4) {
      const doc = memberData.document_list[0];
      if (!doc?.name?.trim()) errors.doc_name = "Document name is required";
      if (!doc?.url) errors.doc_url = "Please upload a document file";
    }

    return errors;
  };

  const handleNext = () => {
    const errors = validateSection(activeSection);
    if (Object.keys(errors).length > 0) {
      setFieldErrors(errors);
      toast.error("Please fix the highlighted fields before continuing");
      return;
    }
    setFieldErrors({});
    setActiveSection((s) => Math.min(sections.length - 1, s + 1));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    // Validate all sections before final submit
    let allErrors = {};
    for (let i = 0; i <= 4; i++) {
      allErrors = { ...allErrors, ...validateSection(i) };
    }

    if (Object.keys(allErrors).length > 0) {
      setFieldErrors(allErrors);
      toast.error("Please complete all required fields");
      return;
    }

    try {
      const response = await dispatch(addTeamMember(memberData));
      if (response.statusCode === 200) navigate("/team");
      setMemberData({
        profile_image: "", name: "", email: "", country_code: "", contact_number: "",
        role: "", timezone: "", pwd: "", lat: "12", lng: "12", gender: "", age: "",
        dob: "", city: "", state: "", country: "", joining_date: "",
        qualifications: [{ degree: "" }], experience: "", address: "", branch_address: "",
        department: "", zip_code: "", designation: "", document_list: [{ name: "", url: "" }],
        bank_details: [{ acc_num: "", ifsc: "", acc_holder_name: "" }],
      });
      setConfirmPass(""); setReAccount(""); setAccMatch(true); setPreviewImage(null);
      setSelectedCountryName(""); setSelectedStateName(""); setSelectedCityName("");
      setFieldErrors({});
    } catch (error) {
      console.log(error);
      toast.error("Failed to add team member");
    }
  };

  const EyeIcon = ({ open }) => open ? (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  ) : (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
      <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
      <line x1="1" y1="1" x2="23" y2="23" />
    </svg>
  );

  return (
    <MainLayout>
      <div className="atm-wrapper" style={{ width: "100%", maxWidth: "100%", boxSizing: "border-box" }}>
        {/* Header */}
        <div className="atm-header">
          <div className="atm-header-left">
            <div className="atm-header-icon">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <line x1="19" y1="8" x2="19" y2="14" />
                <line x1="22" y1="11" x2="16" y2="11" />
              </svg>
            </div>
            <div>
              <h1 className="atm-title">Add Team Member</h1>
              <p className="atm-subtitle">Fill in the details to onboard a new member</p>
            </div>
          </div>
          <Link to="/team" className="atm-view-btn">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
              <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
            View Team
          </Link>
        </div>

        {/* Nav Pills */}
        <div className="atm-nav">
          {sections.map((sec, i) => (
            <button
              key={i}
              className={`atm-nav-pill ${activeSection === i ? "atm-nav-pill--active" : ""}`}
              onClick={() => setActiveSection(i)}
              type="button"
            >
              <span className="atm-nav-num">{String(i + 1).padStart(2, "0")}</span>
              {sec}
            </button>
          ))}
        </div>

        <form className="atm-form">

          {/* ───── SECTION 0: PERSONAL INFO ───── */}
          <div className={`atm-section ${activeSection === 0 ? "atm-section--visible" : ""}`}>
            <div className="atm-section-header">
              <span className="atm-section-badge">01</span>
              <h2 className="atm-section-title">Personal Information</h2>
            </div>

            {/* Profile Image */}
            <div className="atm-avatar-row">
              <div className="atm-avatar-wrap">
                {previewImage ? (
                  <img src={previewImage} alt="Profile" className="atm-avatar-img" />
                ) : (
                  <div className="atm-avatar-placeholder">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                      <circle cx="12" cy="8" r="4" />
                      <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" />
                    </svg>
                  </div>
                )}
                <label className="atm-avatar-upload-btn" htmlFor="atm-profile-img">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                    <polyline points="17 8 12 3 7 8" />
                    <line x1="12" y1="3" x2="12" y2="15" />
                  </svg>
                </label>
                <input id="atm-profile-img" type="file" accept="image/*" className="atm-hidden-input" onChange={handleImageChange} />
              </div>
              <div className="atm-avatar-info">
                <p className="atm-avatar-label">Profile Photo</p>
                <p className="atm-avatar-hint">JPG, PNG or GIF · Max 5MB</p>
              </div>
            </div>

            <div className="atm-grid atm-grid-2">
              <div className="atm-field">
                <label className="atm-label">Full Name <span className="atm-req">*</span></label>
                <input
                  className={`atm-input ${fieldErrors.name ? "atm-input--error" : ""}`}
                  type="text" name="name" value={memberData.name}
                  onChange={handleAddChange} placeholder="e.g. Jane Cooper"
                />
                {fieldErrors.name && <span className="atm-error-msg">{fieldErrors.name}</span>}
              </div>

              <div className="atm-field">
                <label className="atm-label">Email Address <span className="atm-req">*</span></label>
                <input
                  className={`atm-input ${fieldErrors.email ? "atm-input--error" : ""}`}
                  type="email" name="email" value={memberData.email}
                  onChange={handleAddChange} placeholder="jane@company.com"
                />
                {fieldErrors.email && <span className="atm-error-msg">{fieldErrors.email}</span>}
              </div>

              <div className="atm-field">
                <label className="atm-label">Country Code <span className="atm-req">*</span></label>
                <select
                  className={`atm-select ${fieldErrors.country_code ? "atm-input--error" : ""}`}
                  name="country_code" value={memberData.country_code} onChange={handleAddChange}
                >
                  <option value="">Select country code</option>
                  {countryList?.data?.map((country) => (
                    <option key={country._id} value={country.country_phone_code}>
                      {country.country_phone_code} — {country.country_name}
                    </option>
                  ))}
                </select>
                {fieldErrors.country_code && <span className="atm-error-msg">{fieldErrors.country_code}</span>}
              </div>

              <div className="atm-field">
                <label className="atm-label">Phone Number <span className="atm-req">*</span></label>
                <input
                  className={`atm-input ${fieldErrors.contact_number ? "atm-input--error" : ""}`}
                  type="text" name="contact_number" value={memberData.contact_number}
                  onChange={handleAddChange} placeholder="Enter phone number"
                />
                {fieldErrors.contact_number && <span className="atm-error-msg">{fieldErrors.contact_number}</span>}
              </div>

              <div className="atm-field">
                <label className="atm-label">Gender <span className="atm-req">*</span></label>
                <select
                  className={`atm-select ${fieldErrors.gender ? "atm-input--error" : ""}`}
                  name="gender" value={memberData.gender} onChange={handleAddChange}
                >
                  <option value="">Select gender</option>
                  {enumsData?.data?.Gender && Object.entries(enumsData.data.Gender).map(([key, value]) => (
                    <option key={key} value={value}>{ToFirstCapital(value)}</option>
                  ))}
                </select>
                {fieldErrors.gender && <span className="atm-error-msg">{fieldErrors.gender}</span>}
              </div>

              <div className="atm-field">
                <label className="atm-label">Date of Birth <span className="atm-req">*</span></label>
                <input
                  className={`atm-input ${fieldErrors.dob ? "atm-input--error" : ""}`}
                  type="date" name="dob" value={memberData.dob}
                  max={todayStr}
                  onChange={handleAddChange}
                />
                {fieldErrors.dob && <span className="atm-error-msg">{fieldErrors.dob}</span>}
              </div>

              <div className="atm-field">
                <label className="atm-label">Age <span className="atm-req">*</span></label>
                <input
                  className={`atm-input ${fieldErrors.age ? "atm-input--error" : ""}`}
                  type="number" name="age" value={memberData.age}
                  onChange={handleAddChange} placeholder="e.g. 28" min="18"
                />
                {fieldErrors.age && <span className="atm-error-msg">{fieldErrors.age}</span>}
              </div>
            </div>
          </div>

          {/* ───── SECTION 1: WORK DETAILS ───── */}
          <div className={`atm-section ${activeSection === 1 ? "atm-section--visible" : ""}`}>
            <div className="atm-section-header">
              <span className="atm-section-badge">02</span>
              <h2 className="atm-section-title">Work Details</h2>
            </div>
            <div className="atm-grid atm-grid-2">
              <div className="atm-field">
                <label className="atm-label">Role <span className="atm-req">*</span></label>
                <select
                  className={`atm-select ${fieldErrors.role ? "atm-input--error" : ""}`}
                  name="role" value={memberData.role} onChange={handleAddChange}
                >
                  <option value="">Select role</option>
                  {enumsData?.data?.Roles && Object.entries(enumsData.data.Roles)
                    .filter(([, v]) => !["admin", "super_admin", "builder", "reviewer"].includes(v))
                    .map(([key, value]) => (
                      <option key={key} value={value}>{ToFirstCapital(value)}</option>
                    ))}
                </select>
                {fieldErrors.role && <span className="atm-error-msg">{fieldErrors.role}</span>}
              </div>

              <div className="atm-field">
                <label className="atm-label">Designation <span className="atm-req">*</span></label>
                <input
                  className={`atm-input ${fieldErrors.designation ? "atm-input--error" : ""}`}
                  type="text" name="designation" value={memberData.designation}
                  onChange={handleAddChange} placeholder="e.g. Senior Developer"
                />
                {fieldErrors.designation && <span className="atm-error-msg">{fieldErrors.designation}</span>}
              </div>

              <div className="atm-field">
                <label className="atm-label">Department <span className="atm-req">*</span></label>
                <select
                  className={`atm-select ${fieldErrors.department ? "atm-input--error" : ""}`}
                  name="department" value={memberData.department} onChange={handleAddChange}
                >
                  <option value="">Select department</option>
                  {deptArray.map((dept) => (
                    <option key={dept} value={dept}>{ToFirstCapital(dept)}</option>
                  ))}
                </select>
                {fieldErrors.department && <span className="atm-error-msg">{fieldErrors.department}</span>}
              </div>

              <div className="atm-field">
                <label className="atm-label">Time Zone <span className="atm-req">*</span></label>
                <select
                  className={`atm-select ${fieldErrors.timezone ? "atm-input--error" : ""}`}
                  name="timezone" value={memberData.timezone} onChange={handleAddChange}
                >
                  <option value="">Select timezone</option>
                  {enumsData?.data?.time_zones && Object.entries(enumsData.data.time_zones).map(([key, value]) => (
                    <option key={key} value={key}>{value.offset_UTC} ({value.timezone})</option>
                  ))}
                </select>
                {fieldErrors.timezone && <span className="atm-error-msg">{fieldErrors.timezone}</span>}
              </div>

              <div className="atm-field">
                <label className="atm-label">Joining Date <span className="atm-req">*</span></label>
                <input
                  className={`atm-input ${fieldErrors.joining_date ? "atm-input--error" : ""}`}
                  type="date" name="joining_date" value={memberData.joining_date}
                  max={todayStr}
                  onChange={handleAddChange}
                />
                {fieldErrors.joining_date && <span className="atm-error-msg">{fieldErrors.joining_date}</span>}
              </div>

              <div className="atm-field">
                <label className="atm-label">Experience (years) <span className="atm-req">*</span></label>
                <input
                  className={`atm-input ${fieldErrors.experience ? "atm-input--error" : ""}`}
                  type="number" name="experience" value={memberData.experience}
                  onChange={handleAddChange} placeholder="e.g. 3" min="0"
                />
                {fieldErrors.experience && <span className="atm-error-msg">{fieldErrors.experience}</span>}
              </div>

              <div className="atm-field">
                <label className="atm-label">Qualification <span className="atm-req">*</span></label>
                <select
                  className={`atm-select ${fieldErrors.qualifications ? "atm-input--error" : ""}`}
                  name="qualifications"
                  value={memberData.qualifications[0]?.degree || ""}
                  onChange={(e) => {
                    setMemberData((prev) => ({ ...prev, qualifications: [{ degree: e.target.value }] }));
                    clearError("qualifications");
                  }}
                >
                  <option value="">Select qualification</option>
                  {enumsData?.data?.qualification && Object.entries(enumsData.data.qualification).map(([key, value]) => (
                    <option key={key} value={value}>{value}</option>
                  ))}
                </select>
                {fieldErrors.qualifications && <span className="atm-error-msg">{fieldErrors.qualifications}</span>}
              </div>

              <div className="atm-field">
                <label className="atm-label">Branch Address <span className="atm-req">*</span></label>
                <input
                  className={`atm-input ${fieldErrors.branch_address ? "atm-input--error" : ""}`}
                  type="text" name="branch_address"
                  value={memberData.branch_address} onChange={handleAddChange}
                  placeholder="Enter branch address"
                />
                {fieldErrors.branch_address && <span className="atm-error-msg">{fieldErrors.branch_address}</span>}
              </div>
            </div>
          </div>

          {/* ───── SECTION 2: SECURITY ───── */}
          <div className={`atm-section ${activeSection === 2 ? "atm-section--visible" : ""}`}>
            <div className="atm-section-header">
              <span className="atm-section-badge">03</span>
              <h2 className="atm-section-title">Security</h2>
            </div>
            <div className="atm-grid atm-grid-2">
              <div className="atm-field">
                <label className="atm-label">Password <span className="atm-req">*</span></label>
                <div className="atm-input-wrap">
                  <input
                    className={`atm-input atm-input--icon ${fieldErrors.pwd ? "atm-input--error" : ""}`}
                    type={showPassword ? "text" : "password"}
                    name="pwd" value={memberData.pwd}
                    onChange={handleAddChange}
                    placeholder="Create a strong password"
                  />
                  <button
                    type="button"
                    className="atm-eye-btn"
                    onClick={() => setShowPassword((v) => !v)}
                    tabIndex={-1}
                  >
                    <EyeIcon open={showPassword} />
                  </button>
                </div>
                {fieldErrors.pwd && <span className="atm-error-msg">{fieldErrors.pwd}</span>}
              </div>

              <div className="atm-field">
                <label className="atm-label">Confirm Password <span className="atm-req">*</span></label>
                <div className="atm-input-wrap">
                  <input
                    className={`atm-input atm-input--icon ${fieldErrors.confirmPass ? "atm-input--error" : ""}`}
                    type={showConfirmPassword ? "text" : "password"}
                    value={confirmPass}
                    onChange={(e) => { setConfirmPass(e.target.value); clearError("confirmPass"); }}
                    onBlur={handleCheckPass}
                    placeholder="Re-enter password"
                  />
                  <button
                    type="button"
                    className="atm-eye-btn"
                    onClick={() => setShowConfirmPassword((v) => !v)}
                    tabIndex={-1}
                  >
                    <EyeIcon open={showConfirmPassword} />
                  </button>
                </div>
                {fieldErrors.confirmPass && <span className="atm-error-msg">{fieldErrors.confirmPass}</span>}
              </div>
            </div>

            <div className="atm-pass-rules">
              <p className="atm-pass-rule-title">Password requirements:</p>
              <ul className="atm-pass-rule-list">
                <li>At least 8 characters long</li>
                {/* <li>Contains uppercase and lowercase letters</li> */}
                <li>Includes at least one number</li>
              </ul>
            </div>
          </div>

          {/* ───── SECTION 3: ADDRESS ───── */}
          <div className={`atm-section ${activeSection === 3 ? "atm-section--visible" : ""}`}>
            <div className="atm-section-header">
              <span className="atm-section-badge">04</span>
              <h2 className="atm-section-title">Address Details</h2>
            </div>
            <div className="atm-grid atm-grid-2">
              <div className="atm-field atm-field--full">
                <label className="atm-label">Street Address <span className="atm-req">*</span></label>
                <input
                  className={`atm-input ${fieldErrors.address ? "atm-input--error" : ""}`}
                  type="text" name="address" value={memberData.address}
                  onChange={handleAddChange} placeholder="Street, building, apartment…"
                />
                {fieldErrors.address && <span className="atm-error-msg">{fieldErrors.address}</span>}
              </div>

              <div className="atm-field">
                <label className="atm-label">Country <span className="atm-req">*</span></label>
                <select
                  className={`atm-select ${fieldErrors.country ? "atm-input--error" : ""}`}
                  name="country" value={selectedCountryName} onChange={handleAddChange}
                >
                  <option value="">Select country</option>
                  {countryList?.data?.map((country) => (
                    <option key={country._id} value={country.country_name}>{country.country_name}</option>
                  ))}
                </select>
                {fieldErrors.country && <span className="atm-error-msg">{fieldErrors.country}</span>}
              </div>

              <div className="atm-field">
                <label className={`atm-label ${!stateData.country ? "atm-label--disabled" : ""}`}>
                  State <span className="atm-req">*</span>
                </label>
                <select
                  className={`atm-select ${fieldErrors.state ? "atm-input--error" : ""} ${!stateData.country ? "atm-select--disabled" : ""}`}
                  name="state" value={selectedStateName} onChange={handleAddChange}
                  disabled={!stateData.country}
                >
                  <option value="">{stateData.country ? "Select state" : "Select country first"}</option>
                  {states?.data?.map((state) => (
                    <option key={state._id} value={state.state_name}>{state.state_name}</option>
                  ))}
                </select>
                {fieldErrors.state && <span className="atm-error-msg">{fieldErrors.state}</span>}
              </div>

              <div className="atm-field">
                <label className={`atm-label ${!cityData.state ? "atm-label--disabled" : ""}`}>
                  City <span className="atm-req">*</span>
                </label>
                <select
                  className={`atm-select ${fieldErrors.city ? "atm-input--error" : ""} ${!cityData.state ? "atm-select--disabled" : ""}`}
                  name="city" value={selectedCityName} onChange={handleAddChange}
                  disabled={!cityData.state}
                >
                  <option value="">{cityData.state ? "Select city" : "Select state first"}</option>
                  {cities?.data?.map((city) => (
                    <option key={city._id} value={city.city_name}>{city.city_name}</option>
                  ))}
                </select>
                {fieldErrors.city && <span className="atm-error-msg">{fieldErrors.city}</span>}
              </div>

              <div className="atm-field">
                <label className="atm-label">Zip / Postal Code <span className="atm-req">*</span></label>
                <input
                  className={`atm-input ${fieldErrors.zip_code ? "atm-input--error" : ""}`}
                  type="text" name="zip_code" value={memberData.zip_code}
                  onChange={handleAddChange} placeholder="e.g. 400001"
                />
                {fieldErrors.zip_code && <span className="atm-error-msg">{fieldErrors.zip_code}</span>}
              </div>
            </div>
          </div>

          {/* ───── SECTION 4: DOCUMENTS ───── */}
          <div className={`atm-section ${activeSection === 4 ? "atm-section--visible" : ""}`}>
            <div className="atm-section-header">
              <span className="atm-section-badge">05</span>
              <h2 className="atm-section-title">Documents</h2>
            </div>
            <div className="atm-doc-card">
              <div className="atm-doc-icon-wrap">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                  <polyline points="14 2 14 8 20 8" />
                  <line x1="16" y1="13" x2="8" y2="13" />
                  <line x1="16" y1="17" x2="8" y2="17" />
                  <polyline points="10 9 9 9 8 9" />
                </svg>
              </div>
              <div className="atm-doc-fields">
                <div className="atm-field">
                  <label className="atm-label">Document Name <span className="atm-req">*</span></label>
                  <input
                    className={`atm-input ${fieldErrors.doc_name ? "atm-input--error" : ""}`}
                    type="text" value={memberData.document_list[0]?.name || ""}
                    onChange={handleNameChange} placeholder="e.g. Aadhaar Card, Passport…"
                  />
                  {fieldErrors.doc_name && <span className="atm-error-msg">{fieldErrors.doc_name}</span>}
                </div>
                <div className="atm-field">
                  <label className="atm-label">Upload File <span className="atm-req">*</span></label>
                  <label
                    className={`atm-file-upload ${fieldErrors.doc_url ? "atm-file-upload--error" : ""}`}
                    htmlFor="atm-doc-file"
                  >
                    {memberData.document_list[0]?.url ? (
                      <span className="atm-file-uploaded">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12" /></svg>
                        File uploaded successfully
                      </span>
                    ) : (
                      <span className="atm-file-placeholder">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                          <polyline points="17 8 12 3 7 8" />
                          <line x1="12" y1="3" x2="12" y2="15" />
                        </svg>
                        Click to upload document
                      </span>
                    )}
                    <input id="atm-doc-file" type="file" className="atm-hidden-input" onChange={(e) => handleFileChange(e, 0)} />
                  </label>
                  {fieldErrors.doc_url && <span className="atm-error-msg">{fieldErrors.doc_url}</span>}
                </div>
              </div>
            </div>
          </div>

          {/* ───── SECTION 5: BANK DETAILS ───── */}
          <div className={`atm-section ${activeSection === 5 ? "atm-section--visible" : ""}`}>
            <div className="atm-section-header">
              <span className="atm-section-badge">06</span>
              <h2 className="atm-section-title">Bank Details</h2>
            </div>
            <div className="atm-grid atm-grid-2">
              <div className="atm-field">
                <label className="atm-label">Account Number</label>
                <input className="atm-input" type="text" name="acc_num"
                  value={memberData.bank_details[0]?.acc_num || ""}
                  onChange={handleBankDetails} placeholder="Enter account number"
                />
              </div>
              <div className="atm-field">
                <label className="atm-label">Re-Enter Account Number</label>
                <input
                  className={`atm-input ${!accMatch ? "atm-input--error" : ""}`}
                  type="text" value={reAccount}
                  onChange={(e) => setReAccount(e.target.value)}
                  onBlur={handleCheckAcc}
                  placeholder="Confirm account number"
                />
                {!accMatch && <span className="atm-error-msg">Account numbers don't match</span>}
              </div>
              <div className="atm-field">
                <label className="atm-label">IFSC Code</label>
                <input className="atm-input" type="text" name="ifsc"
                  value={memberData.bank_details[0]?.ifsc || ""}
                  onChange={handleBankDetails} placeholder="e.g. SBIN0001234"
                />
              </div>
              <div className="atm-field">
                <label className="atm-label">Account Holder Name</label>
                <input className="atm-input" type="text" name="acc_holder_name"
                  value={memberData.bank_details[0]?.acc_holder_name || ""}
                  onChange={handleBankDetails} placeholder="As per bank records"
                />
              </div>
            </div>
          </div>

          {/* Footer Actions */}
          <div className="atm-footer">
            <div className="atm-footer-nav">
              <button
                type="button"
                className="atm-btn atm-btn--ghost"
                onClick={() => setActiveSection((s) => Math.max(0, s - 1))}
                disabled={activeSection === 0}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="15 18 9 12 15 6" /></svg>
                Back
              </button>
              {activeSection < sections.length - 1 ? (
                <button type="button" className="atm-btn atm-btn--primary" onClick={handleNext}>
                  Next
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="9 18 15 12 9 6" /></svg>
                </button>
              ) : (
                <button type="button" onClick={handleSubmit} className="atm-btn atm-btn--submit">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12" /></svg>
                  Save Member
                </button>
              )}
            </div>
            <Link to="/team" className="atm-btn atm-btn--cancel">Cancel</Link>
          </div>
        </form>
      </div>
    </MainLayout>
  );
};

export default AddTeamMember;